export const Bindings = {
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	UserApiProvider: Symbol("UserApiProvider"),
	LeaguesApiProvider: Symbol("LeaguesApiProvider"),
	PasswordApiProvider: Symbol("PasswordApiProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	CountriesStore: Symbol("CountriesStore"),
	StatesStore: Symbol("StatesStore"),
	RoundsStore: Symbol("RoundsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	UserStore: Symbol("UserStore"),
	LocalizationStore: Symbol("LocalizationStore"),
	LocalizationController: Symbol("LocalizationController"),
	MenuStore: Symbol("MenuStore"),
	MenuController: Symbol("MenuController"),
	StaticContentStore: Symbol("StaticContentStore"),
	AuthController: Symbol("AuthController"),
	LoginController: Symbol("LoginController"),
	RegistrationController: Symbol("RegistrationController"),
	MyAccountController: Symbol("MyAccountController"),
	SecretGateController: Symbol("SecretGateController"),
	HelpController: Symbol("HelpController"),
	HelpListController: Symbol("HelpListController"),
	ContactUsController: Symbol("ContactUsController"),
	ChecksumStore: Symbol("ChecksumStore"),
	LiveScoreController: Symbol("LiveScoreController"),
	ForgotPasswordController: Symbol("ForgotPasswordController"),
	ResetPasswordController: Symbol("ResetPasswordController"),
	SessionController: Symbol("SessionController"),
	BootstrapController: Symbol("BootstrapController"),
	HeaderController: Symbol("HeaderController"),
	LeaguesStore: Symbol("LeaguesStore"),
	MyLeaguesController: Symbol("MyLeaguesController"),
	JoinLeaguesController: Symbol("JoinLeaguesController"),
	CreateLeagueController: Symbol("CreateLeagueController"),
	LeagueController: Symbol("LeagueController"),
	LeagueInviteController: Symbol("LeagueInviteController"),
	LeagueSettingsController: Symbol("LeagueSettingsController"),
	LeagueAboutController: Symbol("LeagueAboutController"),
	LeagueInviteFormController: Symbol("LeagueInviteFormController"),
	ModalsStore: Symbol("ModalsStore"),
	ModalsController: Symbol("ModalsController"),
	GlobalModalsController: Symbol("GlobalModalsController"),
	CookieBannerController: Symbol("CookieBannerController"),
	GameController: Symbol("GameController"),
	PinpointApiProvider: Symbol("PinpointApiProvider"),
	PinpointStore: Symbol("PinpointStore"),
	RoundController: Symbol("RoundController"),
	LandingController: Symbol("LandingController"),
	PickPageController: Symbol("PickPageController"),
	PickController: Symbol("PickController"),
	PlayerSlotController: Symbol("PlayerSlotController"),
	PlayerPoolStore: Symbol("PlayerPoolStore"),
	PoolController: Symbol("PoolController"),
	PoolModalController: Symbol("PoolModalController"),
	PlayerInfoController: Symbol("PlayerInfoController"),
	RoundResultsController: Symbol("RoundResultsController"),
	PrizesController: Symbol("PrizesController"),
	PlayedGamesController: Symbol("PlayedGamesController"),
	ShareController: Symbol("ShareController"),
	ShareStore: Symbol("ShareStore"),
	PredictModalController: Symbol("PredictModalController"),
	FooterController: Symbol("FooterController"),
};
